<ion-header mode="md" *ngIf="!isProtected">
  <ion-toolbar class="ion-text-center">
    <ion-item lines="none">
      <ion-img class="logo" src="../assets/images/app-logo.svg"></ion-img>
    </ion-item>
  </ion-toolbar>
</ion-header>

<app-header
  *ngIf="isProtected"
></app-header>

<ion-content full>
  <div class="box">
    <div class="content">
      <ion-item class="input" lines="none" class="min-height-auto">
        <ion-back-button
          defaultHref="/auth/register"
          text=""
          *ngIf="!isProtected"
        ></ion-back-button>
        <h1>REGULAMIN APLIKACJI</h1>
      </ion-item>

      <div class="paragraph">
        <p><strong>I. Postanowienia Ogólne</strong></p>
        Niniejszy Regulamin (wraz z dokumentami, do których się odnosi)
        informuje o warunkach użytkowania, na których możesz korzystać z
        aplikacji MyBuilding obsługiwanej przez Space Technology Integrator Sp.
        z o. o. Sp. k. z siedzibą w Warszawie ul. al. Armii Ludowej 28, NIP:
        7010910167 e-mail: kontakt&#64;space-tech.it („Usługodawca”). Prosimy o
        uważne zapoznanie się z niniejszymi warunkami użytkowania przed
        rozpoczęciem korzystania z Aplikacji.
        <ol>
          <li>
            Korzystając z naszej Aplikacji, akceptujesz warunki jej użytkowania
            i zgadzasz się ich przestrzegać. Jeśli nie zgadzasz się z
            niniejszymi warunkami użytkowania, powstrzymaj się od korzystania z
            naszej Aplikacji.
          </li>
          <li>
            Administratorem danych osobowych jest Usługodawca. Więcej informacji
            nt przetwarzania danych osobowych przez Space Technology Integrator
            Sp. z o. o. Sp. k. znajdziesz w Rozdziale III Regulaminu oraz pod
            adresem:
            <a href="http://space-tech.it/polityka-prywatnosci.html"
              >http://space-tech.it/polityka-prywatnosci.html</a
            >
          </li>
          <li>
            Aplikacja MyBuilding dostępna pod adresem
            https://my-building.net/auth („Aplikacja”) umożliwia użytkownikom
            korzystającym z sieci elektronicznej (dalej określanym jako
            „Użytkownicy”), dostęp do informacji o budynku, zaproszeniach,
            zgłoszenia i zaproszeniach gości dla osób z odpowiednimi
            uprawieniami, market place z listą dostawców i produktów, miejscach
            parkingowych, salkach i ich rezerwacji w obiektach, w których
            Aplikacja została wdrożona.
          </li>
          <li>
            W celu korzystania z Aplikacji wymagane jest założenie konta
            Użytkownika.
          </li>
          <li>
            Terminy „my”, „nas” lub „nasz” odnoszą się do Space Technology
            Integrator Sp. z o. o. Sp. k.
          </li>
          <li>
            Każdy Użytkownik może w dowolnym czasie uzyskać dostęp do Regulaminu
            poprzez wejście w link „Regulamin” umieszczony na stronie
            internetowej Aplikacji.
          </li>
          <li>
            Regulamin skierowany jest do wszystkich Użytkowników Aplikacji i
            określa zasady dokonywania rejestracji i korzystania z konta w
            Aplikacji, w szczególności:
            <ol type="a">
              <li>zakładania konta Użytkownika i logowania do Aplikacji,</li>
              <li>opisywania konta Użytkownika danymi,</li>
            </ol>
          </li>
          <li>
            Niezależnie od funkcjonalności wskazanych w ust. 3 Aplikacja może
            służyć do:
            <ol type="a">
              <li>rezerwacji miejsc parkingowych,</li>
              <li>wysłania zgłoszenia o usterce w obiekcie,</li>
              <li>sprawdzenia nadchodzących spotkań, rezerwacji,</li>
              <li>
                wyświetlania danych (zdjęcie, numer telefonu, e-mail) innych
                Użytkowników zdefiniowanych jako pracownicy bądź
                administratorzy,
              </li>
              <li>otrzymywania notyfikacji,</li>
            </ol>
          </li>
          <li>
            Jeśli w Aplikacji nie zastrzeżono inaczej, prawa do materiałów
            wizualnych (np. map, zdjęć) przysługują Usługodawcy.
          </li>
          <li>
            Dbamy o to, aby nasza Aplikacja była regularnie aktualizowana, w
            związku z czym możemy zmienić jej zawartość w dowolnym momencie.
            Jeśli zajdzie taka potrzeba, możemy również zawiesić dostęp do
            naszej Aplikacji lub zamknąć ją na czas nieokreślony. Materiały
            znajdujące się w naszej Aplikacji mogą się zdezaktualizować , za co
            nie ponosimy odpowiedzialności.
          </li>
        </ol>
      </div>
      <div class="paragraph">
        <p>
          <strong>II. Zasady korzystania z Aplikacji i świadczenia </strong>
        </p>
        <ol>
          <li>
            Aplikacja przy pomocy sieci elektronicznej umożliwia:
            <ol type="a">
              <li>
                zakładanie konta i logowanie do Aplikacji, opisanie konta danymi
                obowiązkowymi – imię, nazwisko, adres poczty elektronicznej,
                hasło.
              </li>
              <li>
                opisanie konta danymi nieobowiązkowymi – stanowisko, numer
                telefonu, opis, lokalizacja budynku
              </li>
              <li>rezerwację pomieszczeń,</li>
              <li>
                wysłanie zgłoszenia o usterce w obiekcie zawierającego zdjęcie
                zdarzenia, lokalizację usterki, temat wstępnie zdefiniowany
                przez administratora, opis zdarzenia (zgłoszenie wysyłane jest
                osobie zdefiniowanej w panelu administracyjnym Aplikacji),
              </li>
              <li>
                sprawdzanie nadchodzących spotkań, rezerwacji sal, miejsc
                parkingowych, które Użytkownik dodał, bądź został zaproszony
                przez innych Użytkowników,
              </li>
              <li>
                wyświetlanie mapy przestrzeni lub obiektu zawierającej m.in.
                obrys pięter, opis pomieszczeń
              </li>
              <li>wyszukiwanie sal</li>
              <li>
                wyświetlanie danych (zdjęcie osoby, lokalizacja pomieszczenia,
                numer telefonu, e-mail) innych Użytkowników zdefiniowanych jako
                pracownicy bądź administratorzy,
              </li>
              <li>
                otrzymywanie notyfikacji wysyłanych od Użytkowników
                posiadających uprawnienia,
              </li>
              <li>
                wyświetlanie uprzednio zdefiniowanego modułu pytań i odpowiedzi
                (indywidualnie dla każdej przestrzeni lub obiektu),
              </li>
            </ol>
          </li>
          <li>
            Z Aplikacji korzystać mogą użytkownicy telefonów wyposażonych w
            systemy iOS (w wersji 9.0 lub wyższej) i Android (w wersji 4.0.3 lub
            wyższej) a ze strony internetowej – osoby korzystające z
            przeglądarek internetowych Chrome, Safari, Internet Explorer,
            Firefox, Opera (w wersji nie niższej niż dwie ostatnie, udostępnione
            przez wydawcę przeglądarki). Równocześnie, pomimo, iż dokładamy
            wszelkich starań, aby spełniać najwyższe standardy dostępności, nie
            gwarantujemy kompatybilności Aplikacji ze sprzętem i
            oprogramowaniem, z którego mogą korzystać użytkownicy Aplikacji.
          </li>
          <li>
            Usługodawca stosuje środki techniczne i organizacyjne, zapobiegające
            pozyskaniu oraz modyfikacji przez osoby nieupoważnione danych
            podawanych podczas rejestracji
          </li>
          <li>
            Akceptując Regulamin, Użytkownik przyjmuje do wiadomości i wyraża
            zgodę na to, że korzystając z Aplikacji może otrzymywać na swoim
            urządzeniu mobilnym notyfikacje wskazane w punktach I.8.e
            Regulaminu.
          </li>
          <li>
            Użytkownik zobowiązany jest do:
            <ol type="a">
              <li>
                niedostarczania i nieprzekazywania treści zabronionych przez
                przepisy prawa,
              </li>
              <li>
                korzystania z Aplikacji w sposób nie zakłócający jej
                funkcjonowania,
              </li>
              <li>
                nierozsyłania i nieumieszczania w ramach Aplikacji niezamówionej
                informacji handlowej,
              </li>
              <li>
                korzystania z Aplikacji w sposób nieuciążliwy dla innych
                Użytkowników oraz dla Usługodawcy,
              </li>
              <li>
                korzystania z Aplikacji w sposób zgodny z przepisami
                obowiązującymi na terytorium Rzeczypospolitej Polskiej,
                postanowieniami Regulaminu, a także ogólnymi zasadami
                korzystania z sieci Internet.
              </li>
            </ol>
          </li>
        </ol>
      </div>

      <div class="paragraph">
        <p><strong>III. Przetwarzanie danych osobowych </strong></p>
        <ol>
          <li>
            Dane osobowe Użytkownika będą przetwarzane w celu świadczenia
            Użytkownikowi usług w ramach Aplikacji, na podstawie zgody
            udzielonej przez Użytkownika.
          </li>
          <li>
            Instalując Aplikację, Użytkownik wyraża zgodę na wykorzystanie
            danych osobowych oraz podanego podczas rejestracji adresu e-mail w
            celu sprawnego realizowania zadań Aplikacji. Jednocześnie oświadcza,
            że zapoznał się z danymi – opublikowanymi zgodnie z obowiązkiem
            informacyjnym Usługodawcy – w zakresie przetwarzania danych
            osobowych na podstawie wyrażonej przez siebie zgody.
          </li>
          <li>
            Dane osobowe Użytkownika mogą być udostępniane podmiotom zewnętrznym
            – partnerom IT zaangażowanym do obsługi i rozwijania Aplikacji oraz
            Właścicielowi Obiektu objętego działaniem Aplikacji.
          </li>
          <li>
            Dane osobowe Użytkowników będą przechowywane w okresach niezbędnych
            do realizacji wyżej określonego celu, przewidzianych przepisami
            prawa i wewnętrznymi regułami obowiązującymi u Usługodawcy lub do
            czasu wycofania zgody na ich przetwarzanie.
          </li>
          <li>
            Podanie przez Użytkownika danych osobowych jest dobrowolne ale
            niezbędne do realizacji wyżej określonego celu, a brak ich podania
            uniemożliwi sprawne realizowanie w Aplikacji zadań dotyczących
            Użytkownika.
          </li>
          <li>
            Użytkownikowi przysługuje prawo dostępu do treści swoich danych,
            otrzymywania ich kopii oraz, z zastrzeżeniem przepisów prawa,
            przysługuje prawo do:
            <ol type="a">
              <li>sprostowania danych,</li>
              <li>
                cofnięcia udzielonej zgody, z zastrzeżeniem, że cofnięcie zgody
                nie będzie wpływać na zgodność z prawem przetwarzania, którego
                dokonano na podstawie zgody udzielonej przez Użytkownika przed
                jej wycofaniem,
              </li>
              <li>usunięcia danych,</li>
              <li>ograniczenia przetwarzania danych,</li>
              <li>wniesienia sprzeciwu,</li>
              <li>przenoszenia danych.</li>
            </ol>
          </li>
          <li>
            Realizacja wyżej wymienionych praw odbywa się poprzez złożenie
            wniosku do Usługodawcy.
          </li>
          <li>
            Użytkownikowi przysługuje prawo do wniesienia skargi do właściwego
            organu nadzorczego, którym jest Prezes Urzędu Ochrony Danych
            Osobowych, jeśli Użytkownik uzna, że przetwarzanie danych osobowych
            narusza obowiązujące przepisy prawa.
          </li>
          <li>
            Usługodawca nie przekazuje danych osobowych Użytkowników poza teren
            Europejskiego Obszaru Gospodarczego.
          </li>
          <li>
            Usługodawca nie przetwarza danych osobowych podanych za
            pośrednictwem Aplikacji w sposób opierający się na zautomatyzowanym
            przetwarzaniu, w tym na profilowaniu, jednakże przewiduje taką
            możliwość. W przypadku wprowadzenia zautomatyzowanego przetwarzania
            Użytkownik zostanie poproszony o wyrażenie stosownej zgody
          </li>
        </ol>
      </div>
      <div class="paragraph">
        <p><strong>IV. Postępowanie reklamacyjne </strong></p>
      </div>
      <div class="paragraph">
        <ol>
          <li>
            Usługodawca podejmuje działania w celu zapewnienia w pełni
            poprawnego funkcjonowania Aplikacji w takim zakresie, jaki wynika z
            aktualnej wiedzy technicznej i zobowiązuje się usunąć w rozsądnym
            terminie wszelkie nieprawidłowości zgłoszone przez Użytkowników.
          </li>
          <li>
            Użytkownik może zgłosić mailowo lub telefonicznie informacje o
            wszelkich niedogodnościach lub przerwach w funkcjonowaniu Aplikacji.
          </li>
          <li>
            Ewentualne reklamacje dotyczące działania Aplikacji należy kierować
            na adres e-mail:kontakt&#64;space-tech.it lub pisemnie na adres
            Usługodawcy wskazany w pkt. I.1.
          </li>
          <li>
            Usługodawca ustosunkuje się do żądania wskazanego w reklamacji w
            terminie 14 dni od daty złożenia reklamacji przez Użytkownika.
          </li>
          <li>
            Reklamacja powinna zawierać:
            <ol type="a">
              <li>
                imię i nazwisko składającej ją osoby oraz jej dane adresowe,
              </li>
              <li>
                adres poczty elektronicznej, na który ma zostać wysłana
                odpowiedź na reklamację, gdy reklamujący życzy sobie otrzymać
                odpowiedź na reklamację za pośrednictwem poczty elektronicznej,
              </li>
              <li>dokładny opis wady oraz datę jej stwierdzenia,</li>
              <li>
                wskazanie preferowanego przez Użytkownika formy poinformowania
                go o sposobie rozpatrzenia reklamacji.
              </li>
            </ol>
          </li>
          <li>
            Powyższe zapisy dotyczące postępowania reklamacyjnego nie wyłączają
            obowiązujących regulacji prawnych w tym zakresie i w żaden sposób
            nie ograniczają ewentualnych ustawowych uprawnień Użytkownika. W
            razie jakiejkolwiek sprzeczności Regulaminu z obowiązującymi
            przepisami prawa w zakresie uprawnień Użytkowników, zastosowanie
            znajdują odpowiednie powszechnie obowiązujące przepisy prawa.
          </li>
        </ol>
      </div>

      <div class="paragraph">
        <p><strong>V. Postanowienia końcowe</strong></p>
        <ol>
          <li>
            W sprawach nieuregulowanych niniejszym Regulaminem stosuje się
            odpowiednio przepisy Kodeksu cywilnego lub innych ustaw mających
            odpowiednie zastosowanie.
          </li>
          <li>
            Sądem właściwym dla rozstrzygania ewentualnych sporów jest sąd
            właściwości ogólnej.
          </li>
          <li>
            Usługodawca zastrzega sobie prawo do dokonywania zmian Regulaminu w
            każdym czasie. Zmiany Regulaminu obowiązują od momentu opublikowania
            ich na stronie internetowej Usługodawcy lub w Aplikacji. Zmiany
            Regulaminu nie mogą naruszać praw nabytych Użytkowników
            korzystających z Aplikacji.
          </li>
          <li>
            Usługodawca zastrzega sobie prawo do dokonywania zmian w Aplikacji,
            przy czym zmiany takie nie naruszają praw osób, które skorzystały z
            odpowiedniej funkcji przed dokonaniem ww. zmian.
          </li>
          <li>
            Użytkownik posiadający status konsumenta zgodnie z obowiązującymi
            przepisami prawa posiada między innymi następujące możliwości
            skorzystania z pozasądowych sposobów rozpatrywania reklamacji i
            dochodzenia roszczeń:
            <ol type="a">
              <li>
                uprawniony jest do zwrócenia się do Wojewódzkiego Inspektora
                Inspekcji Handlowej z wnioskiem o wszczęcie postępowania
                mediacyjnego w sprawie polubownego zakończenia sporu między
                Użytkownikiem a Usługodawcą;
              </li>
              <li>
                uprawniony jest do zwrócenia się do stałego polubownego sądu
                konsumenckiego działającego przy wojewódzkim inspektorze
                Inspekcji Handlowej z wnioskiem o rozstrzygnięcie sporu
                wynikłego z zawartej umowy.
              </li>
            </ol>
          </li>
          <li>
            Skorzystanie z dostępnych pozasądowych sposobów rozpatrywania
            reklamacji oraz dochodzenia roszczeń jest możliwe po zakończeniu
            procedury reklamacyjnej i ma charakter dobrowolny – obie strony
            muszą wyrazić zgodę na postępowanie.
          </li>
          <li>
            W celu wszczęcia postępowania należy złożyć do właściwego terenowo
            Wojewódzkiego Inspektoratu Inspekcji Handlowej odpowiedni wniosek –
            w zależności od rodzaju postępowania – wniosek o mediację lub
            wniosek o rozpoznanie sprawy przed polubownym sądem konsumenckim.
            Nie jest wymagany szczególny formularz wniosku, z którego należy
            skorzystać. We wniosku powinno się szczegółowo opisać sprawę i
            zawrzeć wymagane elementy takie jak: dane obu stron, przedmiot
            sporu, żądania, a także dołączyć kserokopie pism zgromadzonych w
            sprawie. Dla ułatwienia, w sekretariacie każdego polubownego sądu
            konsumenckiego, a także na stronach internetowych Wojewódzkich
            Inspektoratów Inspekcji Handlowej dostępne są formularze wniosku o
            mediację oraz wniosku o rozpoznanie sprawy przed polubownym sądem
            konsumenckim.
          </li>
          <li>
            Szczegółowe informacje o pozasądowych sposobach rozpatrywania
            reklamacji i dochodzenia roszczeń dostępne są w siedzibach oraz na
            stronach internetowych powiatowych (miejskich) rzeczników
            konsumentów, organizacji społecznych, do których zadań statutowych
            należy ochrona konsumentów oraz Wojewódzkich Inspektoratów Inspekcji
            Handlowej.
          </li>
          <li>
            Użytkownik posiadający status konsumenta może uzyskać bezpłatną
            pomoc w sprawie rozstrzygnięcia sporu między Użytkownikiem a
            Usługodawcą, korzystając z bezpłatnej pomocy powiatowego
            (miejskiego) rzecznika konsumentów lub organizacji społecznej, do
            której zadań statutowych należy ochrona konsumentów.
          </li>
        </ol>
      </div>

      <div class="paragraph">
        <p><strong>Formularz rejestracyjny #1 (dane obligatoryjne)</strong></p>
        <ul>
          <li>Imię</li>
          <li>Nazwisko</li>
          <li>Adres e-mail</li>
          <li>Hasło</li>
        </ul>
      </div>

      <div class="paragraph">
        <p>
          <strong>Formularz rejestracyjny #2 (dane nieobligatoryjne)</strong>
        </p>
        <ul>
          <li>
            Profil:
            <ul>
              <li>Stanowisko</li>
              <li>Numer telefonu:</li>
              <li>Opis:</li>
              <li>Lokalizacja obiektu lub przestrzeni:</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="paragraph">
        <p><strong>Formularz reklamacji</strong></p>
        <ul>
          <li>Miejscowość, data</li>
          <li>Imię, nazwisko i adres akładającego reklamację</li>
          <li>
            Do: <br />
            Space Technology Integrator So. z o. o. Sp. k.
          </li>
        </ul>
      </div>

      <div class="paragraph">
        <p><strong>Reklamacja</strong></p>
        Niniejszym, działając na podstawie postanowień Rozdziału V regulaminu
        aplikacji Space Technology Integrator Sp. z o. o. Sp. k. oraz przepisów
        Kodeksu cywilnego zawiadamiam, że świadczona przez Państwa usługa
        realizowana za pośrednictwem tej aplikacji nie jest realizowana / jest
        realizowana nieprawidłowo (niepotrzebne skreślić).<br />
        Wadliwość usługi polega na tym, że … .<br />
        Wada została stwierdzona w dniu … .<br />
        W związku z powyższym wnoszę o … .<br />
        Z poważaniem
      </div>
    </div>
  </div>
</ion-content>
